<div class="hls-expansion-group">
  <mat-accordion [multi]="multi" #accordion>
    <slot #slot></slot>
  </mat-accordion>
</div>